import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { InfoPanel } from '@unite-us/app-components';
import { IconNavigationLink, LeftNavigationBar } from 'src/common/Navigation';
import routesToNavConfig from 'pages/backoffice/routesToNavConfig';
import hasBackOfficeAccess from 'src/common/utils/BackOffice/backOffice';
import './BackOffice.scss';

function BackOffice(props) {
  const { showBackOffice, children, route } = props;

  const path = route.path;
  const routes = routesToNavConfig({ route, path });
  const isBackOfficePage = /\/backoffice$/.test(window.location.pathname);
  const isPrdPage = /\/backoffice\/prds$/.test(window.location.pathname);
  const shouldShowInfoPanel = isBackOfficePage || isPrdPage;

  return (
    showBackOffice && (
      <div className="-mx-container-padding min-h-full flex">
        <LeftNavigationBar>
          {routes.map((r) => (
            <IconNavigationLink key={r.label} {...r} />
          ))}
        </LeftNavigationBar>
        <div className="break-normal flex-grow">
          {shouldShowInfoPanel && (
            <div className="pt-6 px-5">
              <InfoPanel
                color="action-blue"
                className="p-4 info-panel border-2 border-solid border-action-blue"
                message={
                  'Please note that Back Office (HQ3 only) will be retired on or shortly after November 30, 2025. ' +
                  'After that date, Mission Control will be the required platform ' +
                  'for all configurations that were previously completed in HQ3'
                }
              />
            </div>
          )}
          {children}
        </div>
      </div>
    )
  );
}

BackOffice.propTypes = {
  children: PropTypes.node.isRequired,
  route: PropTypes.object.isRequired,
  showBackOffice: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    showBackOffice: hasBackOfficeAccess(state),
  };
}

export default connect(mapStateToProps)(BackOffice);
